import React from 'react';
import './index.css';
import clsx from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { More } from 'components';
import QueueAnim from 'rc-queue-anim';
import { useHistory } from 'react-router-dom';

const Construction = () => {
  const history = useHistory();
  const bannerList = [
    {
      key: '1',
      img: '/img/construction1.png',
      title: '数智实验室建设',
      path: '/intelligence',
    },
    {
      key: '2',
      img: '/img/construction2.jpg',
      title: '温州物资检测中心',
      path: '/construction',
    },
    {
      key: '3',
      img: '/img/construction3.png',
      title: '参与国网项目',
      path: '/construction',
    },
  ];

  const breakpoints = {
    // 小屏幕（手机）
    640: {
      slidesPerView: 1,
    },
    // 中等屏幕（平板）
    768: {
      slidesPerView: 1,
    },
    // 大屏幕（桌面）
    1024: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 2,
    },
    1530: {
      slidesPerView: 3,
    },
  };

  const onClick = (path) => {
    history.push(path);
  };

  return (
    <QueueAnim className={clsx('construction')} type={['bottom', 'top']}>
      <div className={clsx('construction-title')} key='construction-title'>
        实验室建设
      </div>
      <div className={clsx('construction-desc')} key='construction-desc'>
        检测实验室“一条龙” 服务和“交钥匙” 工程
      </div>
      <div className={clsx('construction-list')} key='construction-list'>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          autoplay={true}
          loop={false}
          // 关闭底部点设置
          pagination={false}
          breakpoints={breakpoints}
          className={clsx('construction-swiper')}
        >
          {bannerList.map((v) => (
            <SwiperSlide key={v.key}>
              <div className={clsx('construction-item')}>
                <div
                  className={clsx('construction-item-img')}
                  onClick={() => onClick(v.path)}
                >
                  <img src={v?.img} alt='' width={'100%'} height={'100%'} />
                </div>
                <div
                  className={clsx('construction-item__text')}
                  onClick={() => onClick(v.path)}
                >
                  {v?.title}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {/* 更多按钮 */}
      <div key='more'>
        <More path='/construction' />
      </div>
    </QueueAnim>
  );
};

export default Construction;
